// Feature flags are supplied via VITE_FEATURE_* env vars. Anything unset (or set
// to an empty string) falls back to the default below, so a build without the
// vars behaves the same as before they existed.
const flag = (value: string | undefined, fallback: boolean): boolean => {
  if (value === undefined || value === '') {
    return fallback
  }

  return value === 'true' || value === '1'
}

export const useFeatureFlags = (): FeatureFlags => ({
  showUltimateFootrestOption: flag(import.meta.env.VITE_FEATURE_SHOW_ULTIMATE_FOOTREST_OPTION, true),
  showUscan: flag(import.meta.env.VITE_FEATURE_SHOW_USCAN, false),
  offlineValidationDebugLogs: flag(import.meta.env.VITE_FEATURE_OFFLINE_VALIDATION_DEBUG_LOGS, false),
  showUcareTranslations: flag(import.meta.env.VITE_FEATURE_SHOW_UCARE_TRANSLATIONS, true)
})
